export default __webpack_public_path__ + "static/media/universal-resort.467359a4.jpg";